import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Payday} from "../Payday";
import {PaydaySound} from "../sound/PaydaySound";
import {gsap} from "gsap";
import {PaydaySymbol} from "../reels/symbols/PaydaySymbol";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class PaydayNormalResultPresentation implements FlowStatePresentation {

    constructor() {
    }

    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                flowStateController.setSkipCallback();
            }
        });

        // reel stop and claw movement is always the same in this game, a duration of 0.75
        const jurPadding = Payday.gameFlowController.calculatePaddingDuration(0.75);
        tl.add(() => {}, `>${jurPadding}`);

        const clawIndices = Payday.model.clawIndices();
        const currentClawIndices = Payday.reelView.previousClawPositions[Math.floor(clawIndices.length / 2)];
        const somethingMoved = clawIndices.some((clawIndex, index) => clawIndex != currentClawIndices[index]);

        if (Payday.reelView.reel.isQuickStop)
            tl.timeScale(2);

        if (somethingMoved) {
            tl.add(() => {
                Payday.soundPlayer.playSound("clawMoving")
            })
        }
        tl.add(Payday.reelView.moveClawsTo(clawIndices), '<');
        if (somethingMoved) {
            tl.add(() => {
                Payday.soundPlayer.stopSound("clawMoving")
                Payday.soundPlayer.playSound("clawMovingStop")
            }, '>')
        }
        tl.add(Payday.reelView.reel.stop(Payday.model.data.reels))
        tl.add(Payday.reelView.stopConveyorBelts(), '>')
        tl.add(() => {
            Payday.soundPlayer.playSound("reelLanding")
            Payday.soundPlayer.stopSound("reelsSpinning");
            Payday.soundPlayer.stopSound("reelsSpinning2");
            Payday.soundPlayer.stopSound("reelsSpinning3");
        });

        tl.add(() => {
            flowStateController.finish()
        }, '>0.1');
    }
}